import { app } from '../../../app';
import { Controller } from './downloads.controller';

app.component('downloads', {
    templateUrl: require('./downloads.html'),
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/states/public/downloads/downloads.component.js